import type { RulingKind } from '../types';

/** The miss classes a ruling can name: the three the streak uses today (ptc-docs plan 2026-11-02 §1). */
export const MISS_CLASSES = ['wrong-figure', 'missing-figure', 'unconfirmed'] as const;
export const RULING_KINDS: readonly RulingKind[] = ['parser-fix', 'source-defect', 'accepted'];

/** The last `count` months, newest first, as `yyyy-MM` (UTC): the months a run may grade. */
export function recentMonths(now: Date, count = 12): string[] {
  const out: string[] = [];
  for (let i = 0; i < count; i++) {
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1));
    out.push(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`);
  }
  return out;
}
